/* ============================================================
   AXION // SPECIFICATION — Layer 5: COMPUTATIONAL
   The page computes. Every figure is derived live from real data
   (print specs, geometry, selection, time) — never faked — shown
   in the instrument voice. Built in phases; modules self-scope.
     Phase 1 · Live Spec Calculator (PDP): real print figures
       (area, resolution @300DPI, megapixels, sheet weight)
       recomputed from the selected size, stepped count-up.
   Self-contained (injects own CSS). Reduced-motion safe. Works on
   mobile (it aids the buyer). Coherent with L1 tokens / L4 style.
   ============================================================ */
(function () {
  'use strict';
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- inject CSS ----
  var css =
    '.ax-c5{margin:20px 0 6px;font-family:var(--t-mono,var(--font-instr,ui-monospace,Menlo,Consolas,monospace));}' +
    '.ax-c5__h{font-size:10px;letter-spacing:.24em;text-transform:uppercase;color:var(--graphite-400,#9a9a9e);margin:0 0 8px;display:flex;gap:8px;}' +
    '.ax-c5__h s{color:var(--color-accent,#A67C4A);text-decoration:none;}' +
    '.ax-c5__rows{list-style:none;margin:0;padding:0;}' +
    '.ax-c5__rows li{display:flex;justify-content:space-between;gap:14px;padding:7px 0;' +
      'border-top:1px solid var(--color-border,rgba(23,20,15,.12));font-size:11px;letter-spacing:.05em;text-transform:uppercase;}' +
    '.ax-c5__rows li>span:first-child{color:var(--graphite-400,#9a9a9e);flex:0 0 auto;}' +
    '.ax-c5__rows li>span:last-child{color:var(--graphite-400,#9a9a9e);text-align:right;}' +
    '.ax-c5__rows b{color:var(--ink,var(--color-foreground,#17140F));font-weight:600;font-variant-numeric:tabular-nums;}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // ---- shared utils (used by later phases too) ----
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function fmt(n, d) { return d ? n.toFixed(d) : Math.round(n).toLocaleString('en-GB'); }
  function countTo(node, target, decimals) {
    if (REDUCE) { node.textContent = fmt(target, decimals); node.dataset.v = target; return; }
    var start = parseFloat(node.dataset.v || '0') || 0, t0 = null, dur = 460;
    function step(ts) {
      if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      node.textContent = fmt(start + (target - start) * e, decimals);
      if (p < 1) requestAnimationFrame(step); else { node.textContent = fmt(target, decimals); node.dataset.v = target; }
    }
    requestAnimationFrame(step);
  }

  // ---- Phase 1 · Live Spec Calculator ----
  function specComputer() {
    var form = document.querySelector('.product-form'); if (!form) return;
    var SIZE = /(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*in/i;
    var sizeBtns = [].slice.call(form.querySelectorAll('.opt-btn')).filter(function (b) { return SIZE.test(b.textContent); });
    if (!sizeBtns.length) return;                                  // not a print PDP — skip
    var specList = document.querySelector('.product-info .spec-list'); if (!specList) return;
    if (document.querySelector('.ax-c5')) return;                  // idempotent

    var box = el('div', 'ax-c5');
    box.setAttribute('aria-live', 'polite');
    box.innerHTML =
      '<p class="ax-c5__h">▣ COMPUTED · <s data-size>—</s></p>' +
      '<ul class="ax-c5__rows">' +
      '<li><span>Print area</span><span><b data-k="a1">0</b> in² · <b data-k="a2">0</b> cm²</span></li>' +
      '<li><span>Resolution</span><span><b data-k="px">0</b> px · <b data-k="mp">0</b> MP @ 300 DPI</span></li>' +
      '<li><span>Sheet</span><span>200 gsm → <b data-k="g">0</b> g</span></li>' +
      '<li><span>Frame</span><span data-frameval>Unframed</span></li>' +
      '</ul>';
    specList.parentNode.insertBefore(box, specList.nextSibling);

    function activeSize() {
      var b = sizeBtns.filter(function (x) { return x.classList.contains('active'); })[0] || sizeBtns[0];
      var m = b.textContent.match(SIZE); return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]), label: b.textContent.trim() } : null;
    }
    function activeFrame() {
      var fbs = [].slice.call(form.querySelectorAll('.opt-btn')).filter(function (b) { return /frame|unframed|wood/i.test(b.textContent); });
      var a = fbs.filter(function (x) { return x.classList.contains('active'); })[0];
      return a ? a.textContent.trim() : null;
    }
    function recompute() {
      var s = activeSize(); if (!s) return;
      var area = s.w * s.h, cm2 = area * 6.4516, wpx = Math.round(s.w * 300), hpx = Math.round(s.h * 300),
          mp = (wpx * hpx) / 1e6, g = 0.02 * cm2;
      box.querySelector('[data-size]').textContent = s.label.replace(/\s*in$/i, ' IN').toUpperCase();
      countTo(box.querySelector('[data-k=a1]'), area, 0);
      countTo(box.querySelector('[data-k=a2]'), cm2, 0);
      box.querySelector('[data-k=px]').textContent = wpx.toLocaleString('en-GB') + ' × ' + hpx.toLocaleString('en-GB');
      countTo(box.querySelector('[data-k=mp]'), mp, 1);
      countTo(box.querySelector('[data-k=g]'), g, 1);
      var f = activeFrame();
      box.querySelector('[data-frameval]').textContent =
        (f && !/unframed/i.test(f)) ? f.replace(/\s*\+.*$/, '') + ' · perspex glaze' : 'Unframed';
    }
    form.addEventListener('click', function (e) { if (e.target.closest('.opt-btn')) setTimeout(recompute, 0); });
    recompute();
  }

  // ---- CSS for phases 2–4 ----
  var css2 = [
    /* P2 telemetry */
    '.ax-c5-telem{color:var(--instr-read,rgba(23,20,15,.4));}',
    /* P3 parametric construction grid */
    '.ax-c5grid{position:absolute;inset:0;width:100%;height:100%;opacity:0;transition:opacity .5s ease;pointer-events:none;}',
    '.ab--on .ax-c5grid{opacity:1;}',
    '.ax-c5grid line{stroke:rgba(166,124,74,.30);stroke-width:1;vector-effect:non-scaling-stroke;}',
    '.ax-c5ctl{margin-top:1.1rem;opacity:0;max-height:0;overflow:hidden;transition:opacity .5s ease,max-height .5s ease;font-family:var(--t-mono,ui-monospace,Menlo,monospace);}',
    '.ab--on .ax-c5ctl{opacity:1;max-height:260px;}',
    '.ax-c5ctl__h{font-size:10px;letter-spacing:.22em;text-transform:uppercase;color:var(--color-accent,#A67C4A);margin:0 0 .6rem;}',
    '.ax-c5ctl__row{display:flex;align-items:center;gap:10px;}',
    '.ax-c5ctl__rng{flex:1;accent-color:var(--color-accent,#A67C4A);height:2px;cursor:pointer;}',
    '.ax-c5ctl__n{font-size:11px;color:var(--ink,#17140F);font-variant-numeric:tabular-nums;letter-spacing:.04em;}',
    '.ax-c5ctl__phi{margin-top:.6rem;font-family:inherit;font-size:10px;letter-spacing:.14em;text-transform:uppercase;background:transparent;border:1px solid var(--color-border,rgba(23,20,15,.18));color:var(--graphite-400,#9a9a9e);padding:7px 12px;cursor:pointer;transition:border-color .2s,color .2s;}',
    '.ax-c5ctl__phi.on,.ax-c5ctl__phi:hover{border-color:var(--color-accent,#A67C4A);color:var(--color-accent,#A67C4A);}',
    '.ax-c5ctl__read{margin:.7rem 0 0;font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:var(--graphite-400,#9a9a9e);}',
    '.ax-c5ctl__read b{color:var(--ink,#17140F);font-variant-numeric:tabular-nums;}',
    '.ax-c5ctl__read s{color:var(--color-accent,#A67C4A);text-decoration:none;}',
    /* P4 generative mark */
    '.ax-c5mark-wrap{display:flex;align-items:center;gap:12px;margin-top:16px;opacity:.72;}',
    '.ax-c5mark{width:54px;height:54px;flex:0 0 auto;}',
    '.ax-c5mark line{stroke:var(--color-accent,#A67C4A);stroke-width:.6;opacity:.5;}',
    '.ax-c5mark circle{fill:var(--color-accent,#A67C4A);}',
    '.ax-c5mark-lbl{font-family:var(--t-mono,ui-monospace,Menlo,monospace);font-size:9px;letter-spacing:.14em;text-transform:uppercase;color:var(--graphite-400,#9a9a9e);margin:0;line-height:1.5;}'
  ].join('');
  var st2 = document.createElement('style'); st2.textContent = css2; document.head.appendChild(st2);

  var NS = 'http://www.w3.org/2000/svg';
  var PHI = 1.618033988749895;

  // ---- Phase 2 · live instrument telemetry (extends L1) ----
  function instrumentTelemetry() {
    var readout = document.querySelector('.ax-spec__readout'); if (!readout) return;
    if (readout.querySelector('.ax-c5-telem')) return;             // idempotent
    var seg = el('span', 'ax-c5-telem'); readout.insertBefore(seg, readout.querySelector('.lbl') || null);
    var rels = 0, ratio = '';
    var de = document.querySelector('.ab-data');
    if (de) { try { rels = (JSON.parse(de.textContent).relations || []).filter(function (r) { return r.kind !== 'type-scale'; }).length; } catch (e) {} }
    var img = document.querySelector('.ab-art');
    if (img) { var w = +img.getAttribute('width') || 1000, h = +img.getAttribute('height') || 1400;
      function gg(a, b) { return b ? gg(b, a % b) : a; } var d = gg(w, h) || 1; ratio = (w / d) + ':' + (h / d); }
    var ticking = false;
    function read() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? Math.round(window.scrollY / max * 100) : 0;
      seg.textContent = (rels ? ('GEOM ' + rels + 'R' + (ratio ? ' · ' + ratio : '') + ' · ') : '') + 'SCAN ' + pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(read); } }, { passive: true });
    read();
  }

  // ---- Phase 3 · living blueprint (parametric construction grid, live re-compute) ----
  function goldenPts(len, k) {
    var segs = [[0, len]], pts = [];
    for (var n = 0; n < k; n++) {
      segs.sort(function (a, b) { return (b[1] - b[0]) - (a[1] - a[0]); });
      var s = segs.shift(), a = s[0], b = s[1], c = a + (b - a) / PHI;
      pts.push(c); segs.push([a, c], [c, b]);
    }
    pts.sort(function (a, b) { return a - b; }); return pts;
  }
  function livingBlueprint() {
    var fig = document.querySelector('.ax-construction .ab'); if (!fig) return;
    var stage = fig.querySelector('.ab-stage'), side = fig.querySelector('.ab-side'),
        overlay = fig.querySelector('.ab-overlay'), img = fig.querySelector('.ab-art');
    if (!stage || !side || !img) return;
    if (stage.querySelector('.ax-c5grid')) return;                 // idempotent
    var W = +img.getAttribute('width') || 1000, H = +img.getAttribute('height') || 1400;
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('class', 'ax-c5grid'); svg.setAttribute('aria-hidden', 'true');
    stage.insertBefore(svg, overlay || null);                       // under the L2 relations
    var ctl = el('div', 'ax-c5ctl');
    ctl.innerHTML =
      '<p class="ax-c5ctl__h">▣ PARAMETRIC GRID · LIVE</p>' +
      '<div class="ax-c5ctl__row"><input type="range" min="3" max="12" value="6" class="ax-c5ctl__rng" aria-label="Grid modules"><span class="ax-c5ctl__n"><b data-n>6</b> × <b data-n>6</b></span></div>' +
      '<button type="button" class="ax-c5ctl__phi" aria-pressed="false">φ golden section</button>' +
      '<p class="ax-c5ctl__read">MODULE <b data-mod>—</b> px · <b data-cells>—</b> cells · <s data-mode>EVEN</s></p>';
    side.appendChild(ctl);
    var rng = ctl.querySelector('.ax-c5ctl__rng'), phiBtn = ctl.querySelector('.ax-c5ctl__phi'), golden = false;
    function draw(N) {
      var xs, ys;
      if (golden) { xs = goldenPts(W, N - 1); ys = goldenPts(H, N - 1); }
      else { xs = []; ys = []; for (var i = 1; i < N; i++) { xs.push(i * W / N); ys.push(i * H / N); } }
      var s = '';
      xs.forEach(function (x) { s += '<line x1="' + x.toFixed(1) + '" y1="0" x2="' + x.toFixed(1) + '" y2="' + H + '"/>'; });
      ys.forEach(function (y) { s += '<line x1="0" y1="' + y.toFixed(1) + '" x2="' + W + '" y2="' + y.toFixed(1) + '"/>'; });
      svg.innerHTML = s;
      ctl.querySelectorAll('[data-n]').forEach(function (e) { e.textContent = N; });
      ctl.querySelector('[data-mod]').textContent = Math.round(W / N) + '×' + Math.round(H / N);
      ctl.querySelector('[data-cells]').textContent = N * N;
      ctl.querySelector('[data-mode]').textContent = golden ? 'φ GOLDEN' : 'EVEN';
    }
    rng.addEventListener('input', function () { draw(+rng.value); });
    phiBtn.addEventListener('click', function () { golden = !golden; phiBtn.setAttribute('aria-pressed', golden); phiBtn.classList.toggle('on', golden); draw(+rng.value); });
    draw(6);
  }

  // ---- Phase 4 · generative mark + editions (deterministic, footer) ----
  function mulberry(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function generativeMark() {
    var foot = document.querySelector('footer.foot'); if (!foot || foot.querySelector('.ax-c5mark')) return;
    var d = new Date(); var seed = (d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate()) >>> 0;
    var rnd = mulberry(seed), W = 120, H = 120, pts = [], i, j;
    for (i = 0; i < 22; i++) pts.push([rnd() * W, rnd() * H]);
    var s = '';
    for (i = 0; i < pts.length; i++) for (j = i + 1; j < pts.length; j++) {
      var dx = pts[i][0] - pts[j][0], dy = pts[i][1] - pts[j][1];
      if (dx * dx + dy * dy < 620) s += '<line x1="' + pts[i][0].toFixed(1) + '" y1="' + pts[i][1].toFixed(1) + '" x2="' + pts[j][0].toFixed(1) + '" y2="' + pts[j][1].toFixed(1) + '"/>';
    }
    pts.forEach(function (p) { s += '<circle cx="' + p[0].toFixed(1) + '" cy="' + p[1].toFixed(1) + '" r="1.4"/>'; });
    var svg = document.createElementNS(NS, 'svg'); svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('class', 'ax-c5mark'); svg.setAttribute('aria-hidden', 'true'); svg.innerHTML = s;
    var hex = ('00000000' + seed.toString(16)).slice(-8).toUpperCase();
    var wrap = el('div', 'ax-c5mark-wrap');
    wrap.appendChild(svg);
    wrap.appendChild(el('p', 'ax-c5mark-lbl', 'SEED 0x' + hex + ' · f(date)<br>OPEN EDITION · MADE TO ORDER'));
    var fb = foot.querySelector('.foot-bottom') || foot;
    fb.insertBefore(wrap, fb.firstChild);
  }

  function boot() { specComputer(); instrumentTelemetry(); livingBlueprint(); generativeMark(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
